module.exports = "<div>\r\n    <input type=\"number\" [(ngModel)]=\"value\" />\r\n    <button (click)=\"sendValue()\">enter</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pad/pad.component.html
// module id = ./src/app/components/pad/pad.component.html
// module chunks = main